import './detaillant.scss';

class Detaillant {

  constructor(selector) {

    if (document.querySelector(selector)) {
      const element = document.querySelector(selector);
      const yOffset = -200;
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    }
  }
}

window.addEventListener('load', () => {
  new Detaillant('.messages--error');
});
